const WCS_SRC = '//wcs.naver.net/wcslog.js';
const NAVER_ACCOUNT_ID = 's_55a7966d7c00';

let wcsLoadPromise: Promise<void> | null = null;

// wcslog.js를 1회만 로드하고, 이미 로드 중이거나 로드된 경우 재사용한다.
function loadWcsScript(): Promise<void> {
    if (window.wcs) { console.log('[Naver] wcs 이미 로드되어 있음, 재사용'); return Promise.resolve(); }
    if (wcsLoadPromise) {
        console.log('[Naver] wcs 로드 진행중, 대기');
        return wcsLoadPromise;
    }

    console.log('[Naver] wcslog.js 로드 시작');

    wcsLoadPromise = new Promise<void>((resolve, reject) => {
        const existing = document.querySelector<HTMLScriptElement>(
            `script[src = "${WCS_SRC}"]`,
        );

        if (existing) {
            existing.addEventListener('load', () => {
                console.log('[Naver] 기존 script 태그 로드 완료');
                resolve();
            });
            existing.addEventListener('error', () => {
                console.error('[Naver] 기존 script 태그 로드 실패');
                reject(new Error('Failed to load wcslog.js'));
            });
            return;
        }

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = WCS_SRC;
        script.async = true;
        script.onload = () => {
            console.log('[Naver] wcslog.js 신규 로드 완료');
            resolve();
        };
        script.onerror = () => {
            console.error('[Naver] wcslog.js 신규 로드 실패');
            reject(new Error('Failed to load wcslog.js'));
        };
        document.head.appendChild(script);
    });

    return wcsLoadPromise;
}

/* 회원가입 완료 전환 태그 전송 */ 
export async function fireNaverSignupConversion(): Promise<void> {
    console.log('[Naver] fireNaverSignupConversion 호출됨');
    if (!NAVER_ACCOUNT_ID) {
        console.warn('[Naver] VITE_NAVER_ACCOUNT_ID가 설정되지 않았습니다.');
        return;
    }

    try {
        await loadWcsScript();
        console.log('[Naver] wcs 상태:', window.wcs);

        if (!window.wcs) {
            console.warn('[Naver] wcs 로드 실패로 전환 태그를 전송하지 못했습니다.');
            return;
        }

        if (!window.wcs_add) window.wcs_add = {};
        window.wcs_add['wa'] = NAVER_ACCOUNT_ID;
        console.log('[Naver] wcs_add 설정:', window.wcs_add);

        window._conv = { type: 'sign_up' };
        console.log('[Naver] 전송할 _conv:', window._conv);

        window.wcs.trans(window._conv);
        console.log('[Naver] wcs.trans 호출 완료 (sign_up)');
    } catch (e) {
        console.error('[Naver] 회원가입 전환 태그 전송 실패:', e);
    }
}

/* 기본 페이지뷰 추적 (라우트 변경 시마다 호출) */ 
export async function fireNaverPageview(): Promise<void> {
    console.log('[Naver] fireNaverPageview 호출됨');
    if (!NAVER_ACCOUNT_ID) {
        console.warn('[Naver] VITE_NAVER_ACCOUNT_ID가 설정되지 않았습니다.');
        return;
    }

    try {
        await loadWcsScript();

        if (!window.wcs) {
            console.warn('[Naver] wcs 로드 실패로 페이지뷰를 전송하지 못했습니다.');
            return;
        }

        if (!window.wcs_add) window.wcs_add = {};
        window.wcs_add['wa'] = NAVER_ACCOUNT_ID;

        window.wcs.inflow();
        window.wcs_do?.();
        console.log('[Naver] 페이지뷰 전송 완료');
    } catch (e) {
        console.error('[Naver] 페이지뷰 추적 실패:', e);
    }
}

export interface NaverPurchaseItem {
    id: string; // 상품 ID
    name: string; // 상품명
    quantity: number; // 결제 수량
    payAmount: number; // 결제 금액
}

export interface NaverPurchaseParams {
    value: number; // 총 구매액 (필수)
    orderId: string; // 주문 번호
    items?: NaverPurchaseItem[]; // 상품 목록 (선택)
}

/* 구매완료(purchase) 전환 이벤트 전송 */ 
export async function fireNaverPurchaseConversion(params: NaverPurchaseParams,): Promise<void> {
    console.log('[Naver] fireNaverPurchaseConversion 호출됨', params);
    if (!NAVER_ACCOUNT_ID) {
        console.warn('[Naver] VITE_NAVER_ACCOUNT_ID가 설정되지 않았습니다.');
        return;
    }

    try {
        await loadWcsScript();

        if (!window.wcs) {
            console.warn('[Naver] wcs 로드 실패로 구매 전환 태그를 전송하지 못했습니다.');
            return;
        }

        if (!window.wcs_add) window.wcs_add = {};
        window.wcs_add['wa'] = NAVER_ACCOUNT_ID;

        const _conv: Record<string, unknown> = {
            type: 'purchase',
            value: String(params.value),
            id: params.orderId,
        };

        if (params.items && params.items.length > 0) {
            _conv.items = params.items.map((item) => ({
                id: item.id,
                name: item.name,
                quantity: String(item.quantity),
                payAmount: String(item.payAmount),
            }));
        }

        console.log('[Naver] 전송할 _conv (purchase):', _conv);

        window.wcs.trans(_conv);
        console.log('[Naver] wcs.trans 호출 완료 (purchase)');
    } catch (e) {
        console.error('[Naver] 구매 전환 태그 전송 실패:', e);
    }
}